import {
  SYS_BREAKPOINT_LG,
  SYS_BREAKPOINT_MD,
  SYS_BREAKPOINT_XL,
  SYS_BREAKPOINT_SM,
  SYS_BREAKPOINT_XS,
  SYS_BREAKPOINT_2_XL,
} from '@oneaudi/unified-web-common';

const rawBreakpoints = {
  xs: SYS_BREAKPOINT_XS,
  s: SYS_BREAKPOINT_SM,
  m: SYS_BREAKPOINT_MD,
  l: SYS_BREAKPOINT_LG,
  xl: SYS_BREAKPOINT_XL,
  xxl: SYS_BREAKPOINT_2_XL,
};
// Convert string breakpoints to number
export const breakpoints: Breakpoints<number> = Object.fromEntries(
  Object.entries(rawBreakpoints).map(([key, value]) => [
    key,
    parseInt(value.replace('px', ''), 10),
  ]),
) as Breakpoints<number>;

export type BreakpointLabel = 'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl';

export type Breakpoints<T> = {
  [label in BreakpointLabel]: T;
};
